import { quickFacts } from "@/mocks/homeData";

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="hero" className="relative w-full scroll-mt-20 overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20terracotta%20and%20deep%20gold%20textured%20background%20with%20soft%20bokeh%20light%20and%20subtle%20film%20grain%2C%20moody%20dark%20tones%20with%20elegant%20gradient%2C%20premium%20editorial%20atmosphere%2C%20high%20detail%2C%20no%20people%2C%20wide%20composition&width=1600&height=900&seq=jmh-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs tracking-wide text-white/90 backdrop-blur">
          <i className="ri-bookmark-3-line"></i>
          观看入口 · 资源整理 · 渠道指引
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
          继母的诱惑在哪看？一份完整的观看与资源导航
        </h1>

        <p className="mt-5 max-w-3xl text-sm leading-relaxed text-white/80 md:text-base">
          汇总在线播放、官方回看、海外平台与网盘下载等常见渠道类型，整理查找思路与避坑要点，
          帮助你更快找到稳定可用的观看入口，减少无效搜索与反复跳转。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => scrollTo("directory")}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-live-line"></i>
            查看资源渠道导航
          </button>
          <button
            type="button"
            onClick={() => scrollTo("faq")}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/25 bg-white/5 px-6 py-3 text-sm text-white backdrop-blur transition-colors hover:bg-white/15 sm:w-auto"
          >
            <i className="ri-question-line"></i>
            常见问题解答
          </button>
        </div>

        <div className="mt-12 grid w-full max-w-4xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {quickFacts.map((fact) => (
            <div
              key={fact.label}
              className="rounded-lg border border-white/15 bg-white/10 px-4 py-4 text-left backdrop-blur"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500/90 text-white">
                <i className={`${fact.icon} text-base`}></i>
              </span>
              <p className="mt-3 text-xs tracking-wide text-white/60">{fact.label}</p>
              <p className="mt-1 text-sm font-medium text-white">{fact.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}